export default __webpack_public_path__ + "static/media/gallery_03.a5418509.jpg";